<template>
  <div class="bp-page loot">
    <PageName pageName="rewards" />

    <Warning v-if="isDesktop" :warningText="warningText" />

    <LootOne :activeItem="activeItem" />
    <LootList
      :itemsList="getItemsList"
      :currentIndex="active_index"
      @changeActiveItem="changeActiveItem"
    />
    <TabsList
      v-if="maxPages >= 2"
      :tabsLength="maxPages"
      :activeIndex="active_page + 1"
      :showShopTitles="false"
      @changeTab="changeTab"
    />
    <LootButton />
  </div>
</template>
<script>
import "@/assets/loot/styles/loot.styl";
import { mapGetters } from "vuex";

import LootOne from "./blocks/LootOne";
import LootList from "./blocks/LootList";
import LootButton from "./blocks/LootButton";
import TabsList from "@/components/Common/TabsList";
import PageName from "@/components/Common/PageName";

import WindowSizeMixin from "@/components/Common/WindowSizeMixin";
import Warning from "@/components/Common/Warning";

export default {
  name: "Loot",
  components: {
    LootOne,
    LootList,
    LootButton,
    TabsList,
    PageName,
    Warning,
  },

  mixins: [WindowSizeMixin],

  data() {
    return {
      count_per_page: 5,
      active_page: 0,
      active_index: 0,
    };
  },
  computed: {
    ...mapGetters("shop", ["getOpenedItems", "isBoxRepeteable"]),

    warningText() {
      return this.isBoxRepeteable
        ? this.$t("loot.warning.repeteable")
        : this.$t("loot.warning.non_repeteable");
    },
    maxPages() {
      return Math.ceil(this.getOpenedItems.length / this.count_per_page);
    },
    getItemsList() {
      return this.getOpenedItems.slice(
        this.getStartIndex,
        this.getStartIndex + this.count_per_page
      );
    },
    getStartIndex() {
      return this.active_page * this.count_per_page;
    },
    activeItem() {
      return this.getItemsList[this.active_index];
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    changeTab(index) {
      this.active_page = index - 1;
      this.active_index = 0;
    },
    changeActiveItem(index) {
      this.active_index = index;
    },
  },
};
</script>
